import '.d{display:flex;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import '.an{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dz{background:var(--palette-white);}.ssr-plugin'
import '.ay{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.aq{max-width:77.5rem;}.ssr-plugin'
import '.ep{justify-content:stretch;}.ssr-plugin'
import '.cg{position:sticky;}.ssr-plugin'
import '.ch{top:0px;}.ssr-plugin'
import '.ci{z-index:10;}.ssr-plugin'
import '.f4{padding-block:1rem;}.ssr-plugin'
import '.f5{height:3rem;}.ssr-plugin'
import '.bn{justify-content:space-between;}.ssr-plugin'
import '.c6{flex-wrap:wrap;}.ssr-plugin'
import '.f6{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.dw{margin-top:2rem;}.ssr-plugin'
import '.hn{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ac an e dz"
      >
        <div className="ay d r an e"
        >
          <div className="aq d e ep cg ch ci"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="f4 f5 d bn r c6"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="f6 d e ac dw hn aq"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
